let Medscape = window.Medscape || {};
Medscape.modules = Medscape.modules || {};
window.Medscape = Medscape;
export { Medscape }